import * as React from "react";
import useCheckout from "../../../../../../../../../../hooks/adyen/hooks/adyen/useCheckout.js";
import { getBrowserInfo } from "../../../../../../../../../../utils/utils/get-browser-info.js";
import { AdyenPaymentType } from "../../../../../../../../../../models/adyen/models/adyen/payment-type.js";
import { PaymentMethodFormContainer } from "../../../../../../PaymentMethodForm/containers/modules/PaymentMethodsList/containers/Adyen/PaymentMethodForm/containers/PaymentMethodFormContainer.js";
import { usePaymentsUIContext } from "../../../../../../../../../../context/PaymentsUI/context/PaymentsUI/context.js";
const toPaymentMethodFormState = (state, type, cardBrand) => ({
  cardBrand,
  isValid: state.isValid,
  data: {
    browserInfo: getBrowserInfo(),
    holderName: state?.data?.paymentMethod?.holderName ?? "",
    encryptedCardNumber: state?.data?.paymentMethod?.encryptedCardNumber ?? "",
    encryptedExpiryMonth: state?.data?.paymentMethod?.encryptedExpiryMonth ?? "",
    encryptedExpiryYear: state?.data?.paymentMethod?.encryptedExpiryYear ?? "",
    ...type === AdyenPaymentType.Bancontact ? {} : { encryptedSecurityCode: state?.data?.paymentMethod?.encryptedSecurityCode ?? "" }
  }
});
const CreditCardContainer = ({
  onChange,
  additionalOptions,
  type = AdyenPaymentType.Card
}) => {
  const { setCurrentCardBrand } = usePaymentsUIContext();
  const [state, setState] = React.useState();
  const [brand, setBrand] = React.useState();
  const checkout = useCheckout(setState);
  const additional = React.useMemo(
    () => ({
      hasHolderName: true,
      holderNameRequired: true,
      ...additionalOptions,
      onBrand: (obj) => {
        additionalOptions?.onBrand?.(obj);
        setBrand(obj.brand);
        setCurrentCardBrand(obj.brand !== "card" ? obj.brand : void 0);
      }
    }),
    [additionalOptions, setCurrentCardBrand]
  );
  React.useEffect(() => {
    if (state) {
      onChange(toPaymentMethodFormState(state, type, brand));
    }
  }, [brand, state, onChange, type]);
  return /* @__PURE__ */ React.createElement(PaymentMethodFormContainer, { type, checkout, additionalOptions: additional });
};
export {
  CreditCardContainer
};
//# sourceMappingURL=CreditCardContainer.js.map
